export default __webpack_public_path__ + "static/devesecops-support-mobile1-774a55ef0c5a103fb130280ba628761b.jpg";